<template>
  <div id="app">
    <Main/>
  </div>
</template>

<script>
import Main from './components/Main.vue';

export default {
  name: 'App',
  components: {
    Main
  }
};
</script>

<style>
body {
  padding: 0;
  margin: 0;
  text-align: center;
  background: #333;
  background-size: cover;
  font-family: 'Suez One', sans-serif;
}

input, button {
  font-family: 'Suez One', sans-serif;

}
</style>
